export const LOAD_SCHOOL_BOARD_ID = 'LOAD_SCHOOL_BOARD_ID';

const defaultState = null;

export default function schoolBoard(state = defaultState, action) {
  switch (action.type) {
    case LOAD_SCHOOL_BOARD_ID:
      return action.payload;
    default:
      return state;
  }
}

export function loadSchoolBoardId(sb) {
  return dispatch => {
    dispatch({
      type: LOAD_SCHOOL_BOARD_ID,
      payload: sb
    });
    return sb;
  };
}
